import { useQuery } from 'react-query'
import { apiGetVisualAids } from '../api/visual-aids-api'

const VISUAL_AIDS_KEY = 'visual-aids'

export const useVisualAids = ({ vin }) => {
  const {
    status,
    data: visualAids,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [VISUAL_AIDS_KEY, vin],
    async () => {
      const result = await apiGetVisualAids({ vin })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!vin,
    },
  )

  return {
    status,
    visualAids,
    error,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  }
}
